"use client";

import {
  selectTotalItems,
  useCartBootstrap,
  useCartStore,
} from "@/stores/cart";

export function CartIconButton({ className }: { className?: string }) {
  const setOpen = useCartStore((s) => s.setOpen);
  const totalItems = useCartStore(selectTotalItems);
  const hydrated = useCartStore((s) => s.hydrated);

  useCartBootstrap();

  // Step 7.1 commit 3 / AC245: count + aria-label both depend on
  // localStorage state which is unavailable during SSR. Server
  // emits the no-badge variant (hydrated=false initial); client
  // first render emits the same. suppressHydrationWarning guards
  // against the inevitable post-bootstrap attribute drift.
  return (
    <button
      suppressHydrationWarning
      type="button"
      data-testid="cart-icon-button"
      data-count={hydrated ? totalItems : 0}
      aria-label={`Open cart${hydrated && totalItems > 0 ? ` · ${totalItems} items` : ""}`}
      onClick={() => setOpen(true)}
      className={
        "relative inline-flex h-9 w-9 items-center justify-center rounded-full text-brand-text transition-colors hover:bg-brand-surface " +
        (className ?? "")
      }
    >
      <CartIcon />
      {hydrated && totalItems > 0 && (
        <span
          suppressHydrationWarning
          data-testid="cart-icon-badge"
          className="absolute -right-0.5 -top-0.5 inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-brand-teal px-1 text-[10px] font-bold leading-none text-white"
        >
          {totalItems > 99 ? "99+" : totalItems}
        </span>
      )}
    </button>
  );
}

function CartIcon() {
  return (
    <svg
      aria-hidden="true"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 4h2l1.5 9.5a1.5 1.5 0 0 0 1.5 1.3h7.6a1.5 1.5 0 0 0 1.5-1.3L18 7H6" />
      <circle cx="8" cy="17.5" r="1.1" fill="currentColor" stroke="none" />
      <circle cx="15" cy="17.5" r="1.1" fill="currentColor" stroke="none" />
    </svg>
  );
}
